import { DefaultState } from 'store/types';

export const LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST = 'LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST';
export const LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS = 'LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS';
export const LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE = 'LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE';

export interface LocationMatchesRoomsForMassBookingParams {
  lodgingOptionId: string;
  requestsIds: string[];
};

export interface LocationMatchesRoomsForMassBookingDataRow {
  id: string;
  fromDate: string;
  toDate: string;
  pricePerDayPerBed: number;
  type: string;
};

export type LocationMatchesRoomsForMassBookingState = DefaultState & {
  contents?: LocationMatchesRoomsForMassBookingDataRow[];
};

interface LocationMatchesRoomsForMassBookingRequest {
  type: typeof LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST;
};

interface LocationMatchesRoomsForMassBookingSuccess {
  type: typeof LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS,
  contents: LocationMatchesRoomsForMassBookingDataRow[];
}

interface LocationMatchesRoomsForMassBookingFailure {
  type: typeof LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE;
}

export type LocationMatchesRoomsForMassBookingActionTypes = LocationMatchesRoomsForMassBookingRequest | LocationMatchesRoomsForMassBookingSuccess | LocationMatchesRoomsForMassBookingFailure;